import { render, staticRenderFns } from "./Mypage.vue?vue&type=template&id=63a30fce&scoped=true"
import script from "./Mypage.vue?vue&type=script&lang=js"
export * from "./Mypage.vue?vue&type=script&lang=js"
import style0 from "./Mypage.vue?vue&type=style&index=0&id=63a30fce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a30fce",
  null
  
)

export default component.exports